import { alpha } from '@mui/material';

import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

// Theme-aware "Needed" accent, mirroring FieldPresenceWrapper (DEV-4566): the deep
// PURPLE[7] + light PURPLE[1] tint are tuned for a LIGHT backdrop; in dark mode the
// solid light-lavender bar rendered bright with dark text (DEV-4603), so the accent
// lifts to a lighter purple and the fill becomes a low-alpha purple over the dark surface.
const NEEDED_DARK_TINT_ALPHA = 0.16;

const getNeededAccent = palette =>
  palette.mode === 'dark' ? COLOR_PALETTE.PURPLE[4] : COLOR_PALETTE.PURPLE[7];

const getNeededTint = palette =>
  palette.mode === 'dark'
    ? alpha(COLOR_PALETTE.PURPLE[4], NEEDED_DARK_TINT_ALPHA)
    : COLOR_PALETTE.PURPLE[1];

export const getSectionWrapperStyles = ({ isSectionNeeded = false } = {}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  boxSizing: 'border-box',
  minHeight: '28px',
  padding: '4px 8px',
  borderRadius: '4px',
  border: '1px solid transparent',
  ...getConditionalObject(isSectionNeeded, {
    borderLeft: ({ palette }) => `2px solid ${getNeededAccent(palette)}`,
    backgroundColor: ({ palette }) => getNeededTint(palette),
  }),
});

export const goToSectionButtonStyles = {
  minWidth: 'auto',
  padding: '0 4px',
  height: '18px',
  minHeight: '18px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '18px',
  color: ({ palette }) => getNeededAccent(palette),
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
};
